import { Seo } from "@/components/Seo";
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import whyPerchImg6 from '@/assets/why-perch-img6.png';
import whyPerchImg4 from '@/assets/why-perch-img4.jpg';

const earningBullets = [
  'Refer customers and earn passive recurring income',
  'Your referrals receive high-quality AT&T service while paying less',
];

const communityDealsBullets = [
  'Exclusive offers for your community',
  'Some of the lowest mobile phone rates available',
];

const communityBullets = [
  'Builds credit history through on-time payments',
  'Unlimited talk and text to the US and Mexico',
  'Plans starting at $7.99/month',
  'Month-to-month flexibility — no long-term contracts',
  "5G coverage on AT&T's trusted network",
];

const partnerBullets = [
  'Passive recurring income',
  'Marketing materials provided',
  'A product that genuinely benefits your community',
];

const Affiliates = () => {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#000000' }}
    >
      <Seo
        title="Become a Perch Partner"
        description="Earn passive recurring income by referring customers to Perch Mobile. Join our affiliate program and help your community build credit."
        path="/affiliates"
      />
      <Navigation />

      {/* Hero Section - black background */}
      <section className="relative overflow-hidden pt-[74px] px-4 md:px-8 lg:px-[76px] py-24 md:py-32 max-w-[1514px] mx-auto w-full">
        <div
          className="absolute top-0 left-0 w-[600px] h-[600px] rounded-full pointer-events-none"
          style={{
            background:
              'radial-gradient(ellipse at center, rgba(176, 241, 141, 0.2) 0%, transparent 70%)',
          }}
        />
        <div className="relative flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left: Text */}
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left max-w-xl">
            <h1
              className="text-white font-['Instrument_Sans'] font-semibold text-5xl md:text-6xl lg:text-7xl"
              style={{ letterSpacing: '-0.05em' }}
            >
              Become a <span className="text-mint">Perch Partner</span>
            </h1>
            <p
              className="text-white/70 mt-6 text-xl md:text-2xl font-['Instrument_Sans']"
              style={{ letterSpacing: '-0.03em' }}
            >
              The first mobile service that helps customers build credit history
              with every on-time payment.
            </p>
            <p className="text-white/50 mt-4 text-base font-['Instrument_Sans']">
              Phone bills have never counted toward a credit score — until now.
            </p>
          </div>

          {/* Right: Image */}
          <div className="hidden lg:block flex-shrink-0">
            <div className="rounded-[40px] overflow-hidden w-[380px] h-[500px]">
              <img
                src={whyPerchImg6}
                alt="Person on phone, active lifestyle"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Earning Potential Section - #27243A background */}
      <section className="w-full" style={{ backgroundColor: '#27243A' }}>
        <div className="px-4 md:px-8 lg:px-[76px] py-16 md:py-20 max-w-[1514px] mx-auto w-full">
          <div className="pt-12">
            <h2
              className="text-white font-['Instrument_Sans'] font-semibold text-3xl md:text-4xl mb-8"
              style={{ letterSpacing: '-0.05em' }}
            >
              Earning Potential
            </h2>
            <ul className="flex flex-col gap-3 mb-8">
              {earningBullets.map((item) => (
                <li
                  key={item}
                  className="text-white/70 text-lg font-['Instrument_Sans'] flex items-start gap-3"
                >
                  <span className="text-mint mt-1">—</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            {/* Deals for Your Community Sub-section */}
            <div className="bg-white/5 border border-mint/30 rounded-xl p-8">
              <h3
                className="text-white font-['Instrument_Sans'] font-semibold text-2xl mb-6"
                style={{ letterSpacing: '-0.04em' }}
              >
                Deals for Your Community
              </h3>
              <ul className="flex flex-col gap-3">
                {communityDealsBullets.map((item) => (
                  <li
                    key={item}
                    className="text-white/70 text-lg font-['Instrument_Sans'] flex items-start gap-3"
                  >
                    <span className="text-mint mt-1">—</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Your Community Will Love Perch Section - black background */}
      <section className="w-full" style={{ backgroundColor: '#000000' }}>
        <div className="px-4 md:px-8 lg:px-[76px] py-16 md:py-20 max-w-[1514px] mx-auto w-full">
          <div className="pt-12 flex flex-col lg:flex-row items-center gap-12">
            {/* Left: Text */}
            <div className="flex-1">
              <h2
                className="text-white font-['Instrument_Sans'] font-semibold text-3xl md:text-4xl mb-8"
                style={{ letterSpacing: '-0.05em' }}
              >
                Why Your Community{' '}
                <span className="text-mint">Will Love Perch</span>
              </h2>
              <ul className="flex flex-col gap-3">
                {communityBullets.map((item) => (
                  <li
                    key={item}
                    className="text-white/70 text-lg font-['Instrument_Sans'] flex items-start gap-3"
                  >
                    <span className="text-mint mt-1">—</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: Image */}
            <div className="hidden lg:block flex-shrink-0">
              <div className="rounded-[40px] overflow-hidden w-[380px] h-[440px]">
                <img
                  src={whyPerchImg4}
                  alt="Group of people together"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Partner With Us Section - #27243A background */}
      <section className="w-full" style={{ backgroundColor: '#27243A' }}>
        <div className="px-4 md:px-8 lg:px-[76px] py-16 md:py-20 max-w-[1514px] mx-auto w-full">
          <div className="pt-12">
            <h2
              className="text-white font-['Instrument_Sans'] font-semibold text-3xl md:text-4xl mb-8"
              style={{ letterSpacing: '-0.05em' }}
            >
              Why <span className="text-mint">Partner</span> With Us
            </h2>
            <ul className="flex flex-col gap-3">
              {partnerBullets.map((item) => (
                <li
                  key={item}
                  className="text-white/70 text-lg font-['Instrument_Sans'] flex items-start gap-3"
                >
                  <span className="text-mint mt-1">—</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Section - mint background */}
      <section
        className="w-full py-16 md:py-24"
        style={{ backgroundColor: '#B0F18D' }}
      >
        <div className="px-4 md:px-8 lg:px-[76px] max-w-[1514px] mx-auto w-full text-center">
          <h2
            className="text-black font-['Instrument_Sans'] font-semibold text-3xl md:text-4xl lg:text-5xl"
            style={{ letterSpacing: '-0.05em' }}
          >
            Ready to Get Started?
          </h2>
          <p className="text-black/70 mt-4 text-lg font-['Instrument_Sans']">
            Reach out to us at{' '}
            <span className="text-black font-semibold">
              info@perchmobile.com
            </span>{' '}
            and follow us at{' '}
            <span className="text-black font-semibold">@perchmobile</span>
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Affiliates;
